/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-30 18:01:19
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-08 10:35:03
 */
import React, { useEffect, useState } from "react";
import EChartsReact from "echarts-for-react";

export interface CirclePieProps {
  pieData: any[];
  colorList?: string[];
  pieTitle?: string;
  style?: React.CSSProperties;
}

export const CirclePieCharts: React.FC<CirclePieProps> = ({
  colorList,
  pieTitle,
  pieData,
  style,
}) => {
  const [CirclePieOption, setCirclePieOption] = useState<any>();
  useEffect(() => {
    if (pieData.length) {
      let option = {
        title: {
          text: pieTitle,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "10%",
          orient: "vertical",
          left: "left",
          formatter: function (name: any) {
            var index = 0;
            var clientlabels = pieData.map((v) => v.name);
            var clientcounts = pieData.map((v) => v.value);
            clientlabels.forEach(function (value, i) {
              if (value === name) {
                index = i;
              }
            });
            if (clientcounts[index]) {
              return name + "  " + clientcounts[index] || 0;
            } else {
              return name + "  " + 0;
            }
          },
        },
        series: [
          {
            type: "pie",
            center: ["60%", "60%"],
            radius: "60%",
            data: pieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              minMargin: 20,
              normal: {
                position: 'inner',
                show : false
              }
            },
            color: colorList || [],
          },
        ],
      };
      setCirclePieOption(option);
    }
  }, [pieData]);
  return (
    <>
      {CirclePieOption && (
        <EChartsReact option={CirclePieOption} style={style}></EChartsReact>
      )}
    </>
  );
};
